// extracted by mini-css-extract-plugin
module.exports = {"mentionContainer":"mention-component_mentionContainer__2rkKh"};